import { pipe } from "fp-ts/function";
import { makeWordPressAjaxRequest } from "@/lib/wordpress/ajax";
import {
  GlobalSettingsRevisionsList,
  GlobalSettingsRevisionsListV
} from "@/types/revisions";
import { toUnion } from "fp-ts/Either";
import { mapLeft } from "fp-ts/lib/Either";

export async function fetchRemoteGlobalSettingsRevisions(): Promise<GlobalSettingsRevisionsList | null> {
  return pipe(
    await makeWordPressAjaxRequest({
      action: "breakdance_retrieve_global_settings_revisions",
      decoder: GlobalSettingsRevisionsListV
    }),
    // makeWordPressAjaxRequest does all the error logging already, there's no point to call logErrorsToUiStore()
    mapLeft(() => null),
    toUnion
  );
}
